<template>
    <div class="main-kpi">
        <div class="chart-wrapper-kpi">
            <TotalPo v-if="currentContentSsi === 'total_po'"/>
            <TotalPoAmount v-else-if="currentContentSsi === 'total_po_amount'"/>
            <TopVendor v-else-if="currentContentSsi === 'top_vendor'"/>
            <UserConfirmation v-else-if="currentContentSsi === 'user_confirmation'" @changeContent="changeContent"/>
            <WaitingConfirm v-else-if="currentContentSsi === 'waiting_to_confirm'" @changeContent="changeContent"/>
        </div>
        <div class="card-wrapper-kpi">
            <Card :data="cardData" @changeContent="changeContent"/>
        </div>
    </div>
</template>
<script>
export default {
    components:{
        TotalPo: () => import('@/components/dashboard/main-kpi/ssi-bce/content/total-po.vue'),
        TotalPoAmount: () => import('@/components/dashboard/main-kpi/ssi-bce/content/total-po-amount.vue'),
        TopVendor: () => import('@/components/dashboard/main-kpi/ssi-bce/content/top-vendor.vue'),
        UserConfirmation: () => import('@/components/dashboard/main-kpi/ssi-bce/content/user-confirmation.vue'),
        WaitingConfirm: () => import('@/components/dashboard/main-kpi/ssi-bce/content/waiting-to-confirm.vue'),
        
        Card: ()=> import('@/components/dashboard/main-kpi/ssi-bce/right-card/card.vue')
    },
    data() {
        return {
            currentContentSsi: 'total_po',
            cardData: {
                totalPo: 300,
                totalPoAmount: '1.227.449.038.281',
                topVendor: '227.449.038.281',
                userConfirmation: '48/51'
            }
        };
    },
    methods: {
        changeContent (event) {
            this.currentContentSsi = event;
        }
    },
}
</script>